


// import React, { useEffect, useState } from "react";
// import styles from "../assets/scss/WebHeader.module.scss";

// const Lng = () => {
//   const [language, setLanguage] = useState(
//     localStorage.getItem("appLanguage") || "English"
//   );

//   const languageMap = {
//     English: "en",
//     Tamil: "ta",
//     Hindi: "hi",
//   };

//   // Apply selected language ALWAYS on mount
//   useEffect(() => {
//     const langCode = languageMap[language];

//     let attempts = 0;
//     const timer = setInterval(() => {
//       const select = document.querySelector(".goog-te-combo");
//       if (select) {
//         select.value = langCode;
//         select.dispatchEvent(new Event("change"));
//         clearInterval(timer);
//       }
//       attempts++;

//       if (attempts > 20) clearInterval(timer);
//     }, 300);

//     return () => clearInterval(timer);
//   }, [language]);

//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     localStorage.setItem("appLanguage", lang);

//     setTimeout(() => {
//       const select = document.querySelector(".goog-te-combo");
//       if (select) {
//         select.value = languageMap[lang];
//         select.dispatchEvent(new Event("change"));
//       }
//     }, 300);
//   };

//   return (
//     <div className={styles.card}>
//       <select
//         className={styles.inputs}
//         value={language}
//         onChange={(e) => handleLanguageChange(e.target.value)}
//       >
//         <option value="English">English</option>
//         <option value="Tamil">Tamil</option>
//       </select>
//     </div>
//   );
// };

// export default Lng;

import React, { useEffect, useState } from "react";
import styles from "../assets/scss/WebHeader.module.scss";

const Lng = () => {
  const [language, setLanguage] = useState(
    localStorage.getItem("appLanguage") || "English"
  );

  const languageMap = {
    English: "en",
    Tamil: "ta",
    Telugu: "te",
    Malayalam: "ml",
    Kannada: "kn",
    Hindi: "hi",
  };

  // Apply selected language ALWAYS on mount
  useEffect(() => {
    const langCode = languageMap[language];

    // Add body class for CSS targeting - ALWAYS set on mount
    document.body.className = document.body.className.replace(/lang-\w+/g, '');
    if (language !== 'English') {
      document.body.classList.add(`lang-${langCode}`);
    }

    let attempts = 0;
    const timer = setInterval(() => {
      const select = document.querySelector(".goog-te-combo");
      if (select) {
        select.value = langCode;
        select.dispatchEvent(new Event("change"));
        clearInterval(timer);
      }
      attempts++;

      if (attempts > 20) clearInterval(timer);
    }, 300);

    return () => clearInterval(timer);
  }, [language]);



  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem("appLanguage", lang);

    // Add body class for CSS targeting
    document.body.className = document.body.className.replace(/lang-\w+/g, '');
    if (lang !== 'English') {
      document.body.classList.add(`lang-${languageMap[lang]}`);
    }

    setTimeout(() => {
      const select = document.querySelector(".goog-te-combo");
      if (select) {
        select.value = languageMap[lang];
        select.dispatchEvent(new Event("change"));
      }
    }, 300);
  };

  return (
    <div className={styles.card}>
      <select
        className={`${styles.inputs} notranslate`}
        translate="no"
        value={language}
        onChange={(e) => handleLanguageChange(e.target.value)}
      >
        <option className="notranslate" translate="no" value="English">English</option>
        <option className="notranslate" translate="no" value="Tamil">Tamil</option>
        <option className="notranslate" translate="no" value="Malayalam">Malayalam</option>
        <option className="notranslate" translate="no" value="Hindi">Hindi</option>
        <option className="notranslate" translate="no" value="Telugu">Telugu</option>
        <option className="notranslate" translate="no" value="Kannada">Kannada</option>
      </select>
    </div>
  );
};
export default React.memo(Lng);






// import React, { useEffect, useState } from "react";
// import styles from "../assets/scss/WebHeader.module.scss";

// const Lng = () => {
//   const [language, setLanguage] = useState(
//     localStorage.getItem("appLanguage") || "English"
//   );

//   // 🔤 Full Indian language support
//   const languageMap = {
//     English: "en",
//     Hindi: "hi",
//     Tamil: "ta",
//     Telugu: "te",
//     Malayalam: "ml",
//     Kannada: "kn",
//     Bengali: "bn",
//     Marathi: "mr",
//     Gujarati: "gu",
//     Punjabi: "pa",
//     Odia: "or",
//     Assamese: "as",
//     Urdu: "ur",
//     Nepali: "ne",
//     Sanskrit: "sa",
//     Maithili: "mai",
//     Bhojpuri: "bho",
//     Sindhi: "sd",
//     Konkani: "kok",
//     Manipuri: "mni",
//     Dogri: "doi",
//     Santali: "sat",
//     Kashmiri: "ks",
//   };

//   // 🔁 Apply selected language on mount or when changed
//   useEffect(() => {
//     const langCode = languageMap[language];

//     let attempts = 0;
//     const timer = setInterval(() => {
//       const select = document.querySelector(".goog-te-combo");
//       if (select) {
//         select.value = langCode;
//         select.dispatchEvent(new Event("change"));
//         clearInterval(timer);
//       }
//       attempts++;
//       if (attempts > 20) clearInterval(timer);
//     }, 300);

//     return () => clearInterval(timer);
//   }, [language]);

//   // 🔄 Handle user change
//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     localStorage.setItem("appLanguage", lang);

//     setTimeout(() => {
//       const select = document.querySelector(".goog-te-combo");
//       if (select) {
//         select.value = languageMap[lang];
//         select.dispatchEvent(new Event("change"));
//       }
//     }, 300);
//   };

//   return (
//     <div className={styles.card}>
//       <select
//         className={styles.inputs}
//         value={language}
//         onChange={(e) => handleLanguageChange(e.target.value)}
//       >
//         {Object.keys(languageMap).map((lang) => (
//           <option key={lang} value={lang}>
//             {lang}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// };

// export default Lng;

